import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";


export const getPasesSalidaEncPorFecha = async (data) => {
    return await PrivateInterceptor("Logistica/PasesSalidaEnc", "POST", data);
};

export const getPasesSalidaDetPorFecha = async (data) => {
    return await PrivateInterceptor("Logistica/PasesSalidaDet", "POST", data);
};

export const getPasesSalidaDetPendienteRetorno = async (data) => {
    return await PrivateInterceptor("Logistica/PasesSalidaDetPendienteRetorno", "POST", data);
};

export const getAutorizacionesPases = async () => {
    const respuesta = await PrivateInterceptor(`Logistica/Autorizaciones`, "GET");
    return respuesta;
};

export const AgregarRetorno = (Detalles) => {
    const respuesta = PrivateInterceptor("Logistica/AgregarRetorno", "POST", {Detalles});
    return respuesta;
};
  
export const AgregarAuth = (data) => {
    const respuesta = PrivateInterceptor("Logistica/Autorizaciones/AgregarFirma", "POST", {Detalle: data});
    return respuesta;
};
  
export const ObtenerSiguienteNoPase = () => {
    const respuesta = PrivateInterceptor("Logistica/ObtenerSiguienteNoPase", "GET");
    return respuesta;
};

export const getUserSolicitarPase = async () => {
    const result = await PrivateInterceptor('Logistica/SolicitarPase', 'GET');
    return result;
}

export const GuardarPase = async (data, data2) => {
    const respuesta = PrivateInterceptor("Logistica/GuardarPase", "POST",{Encabezado: data, Detalle: data2});
    return respuesta;
};

export const EditarPase = async (Encabezado, Detalle) => {
    const respuesta = PrivateInterceptor("Logistica/EditarPase", "POST",{Encabezado, Detalle});
    return respuesta;
};

export const getEncabezadoPorId = async (IdPase) => {
    return await PrivateInterceptor("Logistica/EncabezadoPorId", "POST", {IdPase});
};

export const getDetallePorId = async (IdPase) => {
    return await PrivateInterceptor("Logistica/DetallesPorId", "POST", {IdPase});
};

export const getEncabezadoPorNo = async (NoPase) => {
    return await PrivateInterceptor("Logistica/EncabezadoPorNo", "POST", {NoPase});
};

export const getDetallePorNo = async (NoPase) => {
    return await PrivateInterceptor("Logistica/DetallesPorNo", "POST", {NoPase});
};

export const EliminarPase = (data) => {
    const respuesta = PrivateInterceptor("Logistica/EliminarPase", "POST",{Encabezado: data});
    return respuesta;
};

export const EliminarPaseDetalle = (data) => {
    const respuesta = PrivateInterceptor("Logistica/EliminarPaseDet", "POST",{Detalle: data});
    return respuesta;
};
  

export const ObtenerLotesIdVendor = async (IdVendor) => {
    const result = await PrivateInterceptor(`Logistica/PasesSalidaByIdVendor`, "POST", { IdVendor });
    return result;
};